module.exports = __webpack_public_path__ + "img/Aura_trailcombination.1eaf5294.png";